import { StudentSelectionContainer } from "@containers/Checkout/StudentSelectionContainer";

const StudentSelectionPage = () => <StudentSelectionContainer />;

export default StudentSelectionPage;
